angular.module("sublocazioneNoleggio.components", [])
    .component("sublocazioneNoleggio", {
        templateUrl: "ng/components/sublocazioneNoleggio/sublocazioneNoleggio.view.html",
        bindings: {
            richiestePostVendita: "<"
        },
        controllerAs: "sublocazioneNoleggioCtrl",
        controller: SublocazioneNoleggio
    })

function SublocazioneNoleggio(
    $rootScope,
    $modalService,
    $location,
    $RichiestePostVenditaService,
    $arcService,
    $financialApiService,
    $userService,
    DettaglioImmobiliare,
    Sede,
    DatiCatastali,
    RiUserG,
    $giuridicVersion
) {
    var self = this;

    self.$onInit = function () {
        self.$rootScope = $rootScope;
        if (self.richiestePostVendita.viewIndex == 0) {
            self.richiestePostVendita.viewIndex = 1900;
        }
        self.supportModel = {
            tipoVariazione: [],
            variazione: "",
            validityIndirizzo: false,
            validityNewIndirizzo: false,
            validityIndirizzoProprietario: false,
            immobileDiSocTerza: false,
            selectAll: false,
            indirizzoTemp: undefined,
            descrizioneProdotto: "",
            nextValidity: false,
            checklistUploadValidity: false,
            checklistDownloadValidity: false,
            validityCustomer: false,
            options: ["AZIENDA", "PERSONA"],
            frontEndOptions: self.richiestePostVendita.frontEndOptions,
            elencoBeni: [],
            defaultMode: 'AZIENDA',
            topTitle: 'LBL_SUBLOC_NOL'
        }
        self.appContract = {
            numeroContratto: undefined,
            modulo: undefined,
            cdBeni: ""
        }

        if (self.richiestePostVendita.metadata.ctrRichiestaList[0].codProdotto === "IMC" || self.richiestePostVendita.metadata.ctrRichiestaList[0].codProdotto === "IMM") {
            self.richiestePostVendita.metadata.sublocazioneNoleggio.isImmobiliare = true;
            self.supportModel.topTitle = 'LBL_SUBLOC_NOL_IMM'
        }

        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PSB2') {
            self.popolateCheckListDownload();
            self.popolateCheckListUpload();
        } else {
            getContattiCliente();
            getVariazioni();
            if (!self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.length) {

                getElencoBeni();
            }
        }

        if (self.richiestePostVendita && self.richiestePostVendita.metadata && self.richiestePostVendita.metadata.sublocazioneNoleggio && typeof self.richiestePostVendita.metadata.sublocazioneNoleggio.immobileDiSocietaTerza == 'undefined') {
            self.richiestePostVendita.metadata.sublocazioneNoleggio.immobileDiSocietaTerza = true;
        }
        retrieveStepInfo();
        self.validitySublocazione();
    }

    self.handleChange = function (property, value) {
        switch (property) {
            case "tipoVariazione":
                self.supportModel.variazione = value;
                self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione = value;
                break;
            case "emailTerzo":
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.email = value;
                break;
            default:
                break;
        }
        self.validitySublocazione();
    }

    self.onCheckboxChange = function (dettaglio) {
        dettaglio.selected = !dettaglio.selected
        self.validitySublocazione();

    }

    self.selectedDeselectedAll = function () {
        self.supportModel.selectAll = !self.supportModel.selectAll;
        self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.forEach(function (element) {
            element.selected = self.supportModel.selectAll
        })
        self.validitySublocazione();
    }

    var getVariazioni = function () {
        $RichiestePostVenditaService
            .subprocessList(
                self.richiestePostVendita.type,
                self.richiestePostVendita.subtype,
                self.richiestePostVendita.metadata.ctrRichiestaList[0].cluster,
                self.richiestePostVendita.metadata.ctrRichiestaList[0].codProdotto)
            .then(function (response) {
                self.supportModel.tipoVariazione = response.domainList;
                self.validitySublocazione();
            })
            .catch(function (error) {
                console.log(error);
                self.enabledLoader = false;
            });
    }

    var getElencoBeni = function () {
        self.isPending = true;
        self.appContract = self.richiestePostVendita.metadata.ctrRichiestaList.map(function (element) {
            return {
                numeroContratto: element.numeroContratto,
                modulo: element.numeroModulo,
                prodotto: element.codProdotto
            }
        })
        if (self.richiestePostVendita.metadata.sublocazioneNoleggio.isImmobiliare) {
            $arcService.
                getDettaglioReddito(self.appContract[0].numeroContratto, self.appContract[0].modulo)
                .then(function (response) {
                    if (response) {
                        response.dettaglioImmobiliare.forEach(function (element) {
                            var dettaglio = DettaglioImmobiliare.build();
                            dettaglio.codiceBene = element.codiceBene;
                            dettaglio.numero = self.appContract[0].numeroContratto;
                            dettaglio.modulo = self.appContract[0].modulo;
                            dettaglio.indirizzo = Sede.build(element.indirizzo);
                            dettaglio.datiCatastali = DatiCatastali.build(element.datiCatastali);
                            self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.push(dettaglio);
                        });

                        if (self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.length == 1) {
                            self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.selected = true;
                        }

                        self.isPending = false;
                    }
                })

        } else {
            $RichiestePostVenditaService.
                getElencoBeniFromList(self.appContract)
                .then(function (response) {

                    self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio = Object.values(response.mapBeni).flat()

                    if (self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.length == 1) {
                        self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio[0].selected = true;
                    }

                    self.isPending = false;
                    self.validitySublocazione();
                })
                .catch(function (error) {
                    console.log("ERROR:", error)
                    self.isPending = false;
                })
        }
    }

    var retrieveStepInfo = function () {
        self.clearLabelInfo = true;
        $RichiestePostVenditaService
            .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
            .then(function (response) {
                if (response.success) {
                    self.mapInfo = response.message;
                    self.enabledLoader = false;
                }
                self.clearLabelInfo = false;
            })
            .catch(function (error) {
                console.log(error);
                self.enabledLoader = false;
                self.clearLabelInfo = false;
            });
    }

    self.next = function () {
        self.enabledLoader = true;
        cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PSB2') {
            $RichiestePostVenditaService
                .submitSublocazioneNoleggio(self.richiestePostVendita.metadata.sublocazioneNoleggio, self.richiestePostVendita.id,
                    self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf, self.richiestePostVendita.metadata.ctrRichiestaList)
                .then(function (response) {
                    if (response.success) {
                        $location.path('/');
                    }
                    self.enabledLoader = false;

                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                });
        } else {
            $RichiestePostVenditaService
                .generateDocumentsPv(self.richiestePostVendita)
                .then(function (response) {
                    if (response.success) {
                        $RichiestePostVenditaService
                            .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                            .then(function (response) {
                                self.enabledLoader = false;
                                self.richiestePostVendita.viewIndex = response.viewIndex;
                                self.supportModel.frontEndOptions = response.frontEndOptions
                                retrieveStepInfo();
                                self.popolateCheckListDownload();
                                self.popolateCheckListUpload();
                            })
                            .catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            });
                    } else {
                        self.enabledLoader = false;
                    }

                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                });
        }
    }

    self.popolateCheckListDownload = function () {
        self.restDownloadRunning = true;
        $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
            .then(function (response) {
                self.listOfDocumentDownload = response.listDocuments;
                self.visibleDownloadChecklist = response.visible;
                self.restDownloadRunning = false;
            })
            .catch(function (error) {
                console.error(error);
                self.restDownloadRunning = false;
            })
    }

    self.popolateCheckListUpload = function () {
        self.restUploadRunning = true;
        $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
            .then(function (response) {
                self.listOfDocumentUpload = response.listDocuments;
                self.visibleUploadChecklist = response.visible;
                self.message = response.message;
                self.restUploadRunning = false;
            })
            .catch(function (error) {
                console.error(error);
                self.restUploadRunning = false;
            })
    }

    self.exportValiditySede = function (validity) {
        self.supportModel.validityIndirizzo = validity;
        self.validitySublocazione();
    }
    self.exportValidityNewIndirizzo = function (validity) {
        self.supportModel.validityNewIndirizzo = validity;
        self.validitySublocazione();
    }

    self.validityIndirizzoProprietario = function (validity) {
        self.supportModel.validityIndirizzoProprietario = validity;
        self.validitySublocazione();
    }

    self.nextValidity = function () {
        return self.supportModel.nextValidity
    }

    self.validitySublocazione = function () {

        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PSB1') {
            var contractSelected = false;
            var validityContatti = false;
            var validityProprietarioImmobile = false;
            var test = false;

            contractSelected = self.richiestePostVendita.metadata.sublocazioneNoleggio.dettaglio.some(function (element) {
                return element.selected;
            })

            validityContatti = (self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.email &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.telefono &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.description || self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione && self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione.value == 'NOR') &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.email &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.telefono &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.description;

            validityProprietarioImmobile = self.richiestePostVendita.metadata.sublocazioneNoleggio.cfPivaProprietario && self.richiestePostVendita.metadata.sublocazioneNoleggio.ragSocialeProprietario;

            test = contractSelected &&
                self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione &&
                (self.supportModel.validityNewIndirizzo || self.richiestePostVendita.metadata.sublocazioneNoleggio.isImmobiliare || self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione && self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione.value == 'NOR') &&
                validityContatti &&
                (self.supportModel.validityCustomer || self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione && self.richiestePostVendita.metadata.sublocazioneNoleggio.tipoVariazione.value == 'NOR') &&
                (validityProprietarioImmobile || self.richiestePostVendita.metadata.sublocazioneNoleggio.immobileDiSocietaTerza) &&
                (self.supportModel.validityIndirizzoProprietario || self.richiestePostVendita.metadata.sublocazioneNoleggio.immobileDiSocietaTerza);

            if (self.richiestePostVendita.metadata.sublocazioneNoleggio.immOccupTerzi) {
                test = test &&
                    !!self.richiestePostVendita.metadata.sublocazioneNoleggio.ragSocPivaTerzi &&
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.ragSocPivaTerzi.length > 11
            }

            self.supportModel.nextValidity = test;
        } else {
            self.supportModel.nextValidity = self.supportModel.checklistUploadValidity;
        }


        self.nextValidity();
    }

    self.validatePage = function (validity) {
        self.supportModel.nextValidity = validity;
        self.nextValidity();
    }

    self.getWizardMap = function (viewIndex) {
        if (
            $rootScope.wizardMap.find(function (element) {
                return element.index == viewIndex;
            })
        ) {
            return $rootScope.wizardMap.find(function (element) {
                return element.index == viewIndex;
            }).viewName;
        }
    };

    self.sospendi = function () {
        self.loaderSuspend = true;
        $RichiestePostVenditaService
            .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
            .then(function () {
                $modalService.closeModal("suspendInstance");
                self.loaderSuspend = false;
                $location.path('/');
            })
            .catch(function (error) {
                self.loaderSuspend = false;
            })
    }

    self.back = function () {
        if (self.richiestePostVendita.readOnly) {
            $location.path('/');
        } else {
            $RichiestePostVenditaService
                .backStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function (response) {
                    self.enabledLoader = false;
                    self.richiestePostVendita = response;
                    self.supportModel.frontEndOptions = response.frontEndOptions
                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PSB1') {
                        getVariazioni();
                    }
                    retrieveStepInfo();
                    self.validitySublocazione();
                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                })
        }
    }

    self.closeModal = function () {
        $modalService.closeModal("suspendInstance");
    }

    self.exportValidityCustomerDigital = function (value) {
        self.supportModel.validityCustomer = value;
        self.validitySublocazione();
    }

    self.exportValidateCf = function (value) {
        self.supportModel.validityCustomer = value;
        self.validitySublocazione();
    }

    self.exportModel = function (value) {

        if (value) {
            self.richiestePostVendita.metadata.sublocazioneNoleggio.societaTerza.riUserG = value.riUserG;
            var riUserGisOk = RiUserG.build(value.riUserG).isOk(false, false, false, true);
            var checkRiUserF = !!value.riUserF && !!value.riUserF.nome && !!value.riUserF.cognome &&
                !!value.riUserF.residenza &&
                !!value.riUserF.residenza &&
                Sede.build(value.riUserF.residenza).isOk();
            if (value.riUserG && riUserGisOk) {

                if ($giuridicVersion.checkIfInd(value.riUserG.formaGiuridica) && (checkRiUserF || value.riUserG.ndg)) {
                    getContattiSocietaTerza(value.riUserG)
                } else if (!$giuridicVersion.checkIfInd(value.riUserG.formaGiuridica)) {

                    getContattiSocietaTerza(value.riUserG)
                }
            }
        }
        if (value) {
            self.richiestePostVendita.metadata.sublocazioneNoleggio.societaTerza.riUserF = value.riUserF;
        }
        self.validitySublocazione();
    }

    var getContattiCliente = function () {
        if (!!self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.email && !!self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.telefono && !!self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.description) {
            return
        }
        $userService.getDealerUser()
            .then(function (dealer) {
                if (dealer) {
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.email = dealer.email
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.telefono = dealer.tel
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiCliente.description = dealer.name + " " + dealer.surname;
                }
            });
    }

    var getContattiSocietaTerza = function (user) {
        if (self.restIsRunning) {
            return;
        }
        self.restIsRunning = true;
        $rootScope.$broadcast("componentLoader", { action: "OPEN" });
        $financialApiService
            .getContattiCliente(user)
            .then(function (response) {
                if (response && response.riferimenti && response.riferimenti[0]) {
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.email = response.riferimenti[0].email
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.telefono = response.riferimenti[0].telefono
                    self.richiestePostVendita.metadata.sublocazioneNoleggio.contattiSocTerza.description = response.riferimenti[0].description

                }
                self.restIsRunning = false;
                $rootScope.$broadcast("componentLoader", { action: "CLOSE" });
                self.validitySublocazione();
            }).catch(function (error) {
                console.error(error);
                self.restIsRunning = false;
                $rootScope.$broadcast("componentLoader", { action: "CLOSE" });
            });
    }
}
